import React from "react";

const DepartmentsComponent = (props) => {
    const { Renderer } = props;

    return <Renderer {...props} />;
};

export default DepartmentsComponent;
